import { useState, useEffect, useRef } from "react";
import config from "../config/config";
import assets from "../assets/imgs";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const API_URL = config.API_URL;

const PerformanceHooks = (typeKey, typeKeyKor, newDataTitles) => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const filteredDataRef = useRef(filteredData); //초기화

  useEffect(() => {
    filteredDataRef.current = filteredData; // ✅ 최신 값으로 업데이트
  }, [filteredData]);

  const [loading, setLoading] = useState(true);
  const [selectedData, setSelectedData] = useState(null);
  

  const [isModalOpen, setIsModalOpen] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null); // 선택된 데이터 저장

  // tableShow 값이 true인 항목만 추출하여 headTitles 자동 생성
  const headTitles = [{ key: 'id', label: '순번', searchable: false }, ...newDataTitles
    .filter(item => item.tableShow)  // tableShow 값이 true인 항목만 추출
    .map(item => {
      const base = { key: item.key, label: item.label };
      if ('searchable' in item) {
        base.searchable = item.searchable;
      }
      return base;
    })
  ];
  
  const openModal = (type, row = null) => {
    setSelectedRow(row);
    setIsModalOpen(type);
  };
  const closeModal = () => {
    setSelectedRow(null);
    setIsModalOpen(null);
  };
    
  const handleSave = async (formData) =>{
    try {
      console.log('formData: ', formData);
       // 필수 필드 검사
      for (const field of newDataTitles) {
        if (field.req) {
          const value = formData[field.key];
          if (value === "" || value === undefined || value === null) {
            alert(`${field.label}이(가) 없습니다.`);
            return; // 저장 중단
          }
        }
      }

      const {file_data, ...jsonData} = formData;
      const formDataToSend = new FormData();
      formDataToSend.append("file_data", file_data);
      formDataToSend.append("json", JSON.stringify(jsonData));

      const response = await fetch(`${API_URL}/api/startup/${typeKey}Info`, {
        method: "PUT",
        credentials: "include",
        body: formDataToSend,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();

      if (result.result) {
        alert(`${typeKeyKor} 정보가 성공적으로 저장되었습니다.`);
        closeModal();
        fetchData(); // 저장 후 데이터 갱신
      } else {
        console.log(`${result.message}`);
        alert(`저장에 실패하였습니다.`);
      }
    } catch (error) {
      console.error(`Error saving ${typeKey} data:`, error);
      alert("오류가 발생했습니다.");
    }
  }

  const handleDelete = async (_id) =>{
    try {
      const response = await fetch(`${API_URL}/api/startup/${typeKey}Info`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          _id: _id,
        }),
      });

      if(response.status === 403){
        alert("권한이 부족합니다.");
        return;
      }

      if (!response.ok) {
        console.error("서버 오류 응답:", result);
        alert(`삭제 실패: ${result.message || "알 수 없는 오류"}`);
        return;
      }
      const result = await response.json();

      if (result.result) {
        alert("성공적으로 삭제되었습니다.");
        closeModal();
        fetchData(); // 저장 후 데이터 갱신
      } else {
        console.log(`${result.message}`);
        alert(`${result.message} 삭제에 실패했습니다.`);
      }
    } catch (error) {
      console.error(`Error deleting ${typeKey} data:`, error);
      alert("오류가 발생했습니다.");
    }
  }

  const actionMenuItems = [
    { key: "detail", label: "상세보기", icon:<assets.icons.clip_board/>},
    { key: "edit", label: "수정하기", icon: <assets.icons.edit/>},
    { key: "delete", label: "삭제하기", icon: <assets.icons.bin style={{fill:"var(--system-danger_10)"}}/>, style: {color: "var(--system-danger_10)"}},
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/api/startup/${typeKey}Info`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const result = await response.json();
      if (result.result) {
        const formattedData = result.value.map((data, index) => {
          let formatted = { _id: data._id || index + 1, id: index + 1 }; // 기본 ID 설정
        
          newDataTitles.forEach(({ key, tableShow }) => {
            if (tableShow) {
              if (key.endsWith("_date")) {
                formatted[key] = data[key] ? data[key].split("T")[0] : "알 수 없음"; // 날짜 변환
              } else if (key === "amount") {
                formatted[key] = data[key] !== undefined ? data[key] : 0; // 숫자 필드 처리
              } else {
                formatted[key] = data[key] || "알 수 없음"; 
              }

            }
          });
        
          return formatted;
        });
        setData(formattedData);
        setFilteredData(formattedData);

      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleActionMenuClick = async (key, row) => {
    switch (key) {
      case "detail":
        await getData(row._id);
        openModal(key, row._id);
        break;
      case "edit":
        await getData(row._id);
        openModal(key, row._id);
        break;
      case "delete":
        openModal(key, row._id);
        break;
      default:
        break;
    }
  };

  const getData = async (_id) =>{
    try {
      const response = await fetch(`${API_URL}/api/startup/${typeKey}Info`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          _id: _id,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log(result.value);

      if (result.result) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const data =result.value[0];
        
        const selData = newDataTitles.map(({ key, label, type }) => {
          let value;

          if (key.endsWith("_date")) {
            value = data[key] ? data[key].split("T")[0] : "알 수 없음";
          } else {
            value = data[key] || "알 수 없음"; // 기본값 설정
          }
          return {
            key,
            label,
            type,
            value,
            ...(key === "file_name" ? { file_key: data.file_key } : {}) // 파일이면 file_key 추가
          };
        });        
        setSelectedData(selData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      // setError(error.message); // 에러 메시지 저장
    } 
  }

  const downloadFilteredData = () => {
    const dataToDownload = filteredDataRef.current;

    console.log('download 시작');
    console.log(filteredData, data, dataToDownload);
    if (!dataToDownload.length) {
      alert("내보낼 데이터가 없습니다.");
      return;
    }

    const exportData = dataToDownload.map((item, index) => {
      const row = { "순번": index + 1 }; // 첫 컬럼: 순번
      newDataTitles.forEach((title) => {
        if (title.tableShow && title.key !== "_id") { // _id 제외
          const label = title.label;
          const value = item[title.key];
          row[label] = value;
        }
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${typeKeyKor}관리`);

    const now = new Date();
    const year = String(now.getFullYear()).slice(2);
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const fileName = `${typeKeyKor}_리스트.xlsx`;

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(fileData, fileName);
  };

  useEffect(() => {
    fetchData();
  }, []);
  // useEffect(() => {
  //   console.log('filter up');
  //   setFilteredData(data);
  // }, [data]);

  return { data, setData, loading, setLoading, 
    filteredData, setFilteredData, downloadFilteredData,
    headTitles,
    isModalOpen, setIsModalOpen,    
    selectedRow, setSelectedRow, openModal, closeModal, 
    handleDelete, handleSave, actionMenuItems, handleActionMenuClick,
    fetchData, setSelectedData, selectedData };
};

export default PerformanceHooks;